var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F4F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3101 9.69712C12.0925 9.95819 11.9824 10.2923 12.0023 10.6316V25.3705C11.9835 25.7096 12.0934 26.0433 12.3101 26.3049L12.3604 26.3553L20.614 18.0961V17.9003L12.3604 9.64676L12.3101 9.69712Z",
    fill: "url(#paint0_linear_936_131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3669 20.8492L20.6139 18.0961V17.9003L23.3669 15.1528L23.4285 15.1864L26.6907 17.0386C27.6252 17.5645 27.6252 18.4319 26.6907 18.9635L23.4285 20.8156L23.3669 20.8492Z",
    fill: "url(#paint1_linear_936_131)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4285 20.8156L20.6307 18.0178L12.31 26.3049C12.5018 26.4626 12.7406 26.552 12.9888 26.5591C13.2369 26.5662 13.4804 26.4906 13.6809 26.3441L23.4117 20.8156",
    fill: "url(#paint2_linear_936_131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4285 15.1864L13.6809 9.65234C13.4826 9.49986 13.2375 9.42097 12.9874 9.42913C12.7374 9.4373 12.498 9.53202 12.31 9.69711L20.6139 18.001L23.4285 15.1864Z",
    fill: "url(#paint3_linear_936_131)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.367 20.7541L13.681 26.249C13.4878 26.3929 13.2533 26.4707 13.0123 26.4707C12.7714 26.4707 12.5368 26.3929 12.3436 26.249L12.2933 26.2993L12.3436 26.3497C12.5368 26.4936 12.7714 26.5714 13.0123 26.5714C13.2533 26.5714 13.4878 26.4936 13.681 26.3497L23.4118 20.8212L23.367 20.7541Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M12.3101 26.2154C12.0931 25.9518 11.9832 25.6162 12.0023 25.2753V25.3705C11.9836 25.7096 12.0935 26.0433 12.3101 26.3049L12.3604 26.2546L12.3101 26.2154Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M26.6908 18.8627L23.367 20.7541L23.4286 20.8156L26.6908 18.9411C26.8822 18.8569 27.0477 18.7235 27.1706 18.5544C27.2935 18.3853 27.3693 18.1866 27.3903 17.9786C27.3521 18.1709 27.2687 18.3513 27.1471 18.505C27.0255 18.6587 26.8691 18.7814 26.6908 18.8627Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.681 9.75305L26.6908 17.1337C26.8674 17.2131 27.0228 17.333 27.1443 17.4837C27.2658 17.6344 27.3501 17.8116 27.3903 18.001C27.3705 17.7927 27.2951 17.5935 27.1721 17.4242C27.0491 17.2549 26.8829 17.1217 26.6908 17.0385L13.681 9.65233C12.7633 9.12634 12.0023 9.5628 12.0023 10.6316V10.7267C12.0023 9.66352 12.7633 9.22146 13.681 9.75305Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_936_131",
    x1: 19.8865,
    y1: 10.4749,
    x2: 8.70087,
    y2: 21.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_936_131",
    x1: 26.8026,
    y1: 18.001,
    x2: 10.6761,
    y2: 18.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_936_131",
    x1: 21.9009,
    y1: 19.5286,
    x2: 6.73676,
    y2: 34.6928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_936_131",
    x1: 10.2172,
    y1: 4.78975,
    x2: 16.9935,
    y2: 11.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.1e4fbc4e35e2f45110c522ba70e03e63.svg";
export { ForwardRef as ReactComponent };